import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportmenu',
  templateUrl: './reportmenu.component.html',
  styleUrls: ['./reportmenu.component.css']
})
export class ReportmenuComponent implements OnInit {
  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Reports')
        this.pageList=this.menuList[i].KHB_PagesList;

        console.log('Pages');
        console.log(this.pageList);
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/reports/reportmenu/reportmenu.component.ts